export const locale = "ru" as "ru"

export const defaultCurrency = "RUB";
